import { inject } from "mobx-react";
import { Fragment, useMemo } from "react";

import type { BlockInterface } from "@ihr-radioedit/inferno-core";
import type { FeedResultFragment } from "@ihr-radioedit/inferno-webapi";
import { Heading } from "../../../../core/ui";
import { getFeedSubtitle } from "../../lib/coastFeed";
import { CoastFeedNavigation } from "./coast-feed-navigation/CoastFeedNavigation.component";
import { CoastFeedAds } from "./CoastFeedAds.component";
import { CoastFeedNoResults } from "./CoastFeedNoResults.component";
import CoastFeedPhotoItem from "./CoastFeedPhotoItem.component";
import type { Store } from "@inferno/renderer-shared-core";

interface CoastFeedPhotosProps {
  content: FeedResultFragment[] | null;
  block: BlockInterface;
  store?: Store;
  title: string;
}

export const CoastFeedPhotos = inject("store")(({ store, content, block, title }: CoastFeedPhotosProps) => {
  if (!store) {
    return null;
  }

  const subtitle = useMemo(() => getFeedSubtitle(store.routeParams), [store.routeParams]);

  return (
    <Fragment>
      <Heading level={2}>{title}</Heading>
      <Heading level={3}>{subtitle}</Heading>

      <CoastFeedNavigation />

      {content?.length ? (
        <div className="feed-cards">
          {content.map((item, itemIdx) => (
            <Fragment key={item.id}>
              <CoastFeedPhotoItem item={item} />
              <CoastFeedAds
                offsetLoadMore={true}
                blockSize={block.value.size}
                itemCount={(content?.length || 0) - 1}
                includeItemAd={false}
                blockId={block.id}
                itemIdx={itemIdx}
              />
            </Fragment>
          ))}
        </div>
      ) : (
        <CoastFeedNoResults />
      )}
    </Fragment>
  );
});

export default CoastFeedPhotos;
